
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorSeccion } from '@/views/a-pedidos-ml/pc/lista/controlador';
    import { Transporte } from '@/__env/lib/Expedicion/Transportes';
    import * as Pedidos from '@/__env/lib/Ventas/Pedidos';
    import { Pedido } from '@/__env/lib/Ventas/Pedidos';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Wait } from '@/__env/ext';
    import _ from 'lodash';
import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
import { Cliente } from '@/__env/lib/Clientes';

    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorSeccion;
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        @Prop()
        public Abrir: boolean;
        @Watch( 'Abrir' )
        onAbrir()
        {
            this.Abierto = false;
            this.$nextTick( () => { this.Abierto = this.Abrir; } );

        }

        public Cargando: boolean = false;

        public Abierto: boolean = false;
        @Watch( 'Abierto' )
        onAbierto()
        {
            this.Iniciar();
        }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Iniciar();
        }

        Iniciar()
        {
            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Filtros[key] = Number( this.Buscador.Filtros.Valores[key] );
            }
            //this.Transporte = this.Buscador.Filtros.Valores.Logistica;
        }

        public Transporte: Transporte = null;
        public Cliente: Cliente = null;
        public Filtros: Record<string, number> = {
            Cuenta: 0,
            Estado: 0,
            Tag: 0,
            Tipo: 0,
            Limite: 1,
            Orden: 0,
            Indice: 0,
        };

        public async Descargar()
        {
            this.Cargando = true;
            Utiles.GenerandoArchivo( true );

            let a = _.clone( this.Buscador.Filtros.Valores );

            for ( let key of Object.keys( this.Filtros ) )
            {
                this.Buscador.Filtros.Valores[key] = this.Filtros[key];
            }

            if ( this.Transporte )
                this.Buscador.Filtros.Valores.Logistica = this.Transporte;

            if ( this.Cliente )
                this.Buscador.Filtros.Valores.Cliente = this.Cliente;

            let cl = this.Buscador.Filtros.Obtener();
            this.Buscador.Filtros.Valores = a;


            let pdf = await Pedido.URLListado( cl );
            if ( pdf )
            {
                window.open( pdf );
            } else
            {
                Utiles.Notificaciones.Error( `No hay resultados` );

            }
            Utiles.GenerandoArchivo( false );

            this.Cargando = false;
        }

        Cerrar()
        {
            this.Abierto = false;
            this.Controlador.Vista.Filtros.Abierto = false;
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


    }
